export const mockData = {
    attendance: {
        activities: [
            'Formule Anniversaire',
            'Paintball - 30 minutes',
            'Banana Moon',
            'Pulse',
            "Chante! L'expérience",
            'Simulateur F1',
            'Autre activité',
        ],
        hours: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        data: [
            [0, 5, 15, 25, 45, 65, 85, 75, 55, 45, 85, 65, 25, 15, 5, 0],
            [10, 15, 25, 35, 45, 55, 45, 35, 25, 65, 55, 45, 35, 25, 15, 5],
            [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 35, 15, 5, 0],
            [15, 25, 35, 45, 55, 65, 75, 65, 55, 45, 35, 25, 15, 15, 10, 0],
            [0, 5, 10, 15, 25, 35, 45, 55, 65, 75, 85, 95, 85, 45, 25, 0],
            [10, 10, 15, 25, 35, 45, 35, 25, 15, 25, 35, 45, 35, 25, 15, 10],
            [0, 5, 10, 15, 20, 25, 30, 35, 40, 35, 30, 25, 20, 15, 10, 5],
        ],
    },
    trends: [
        { label: "Aujourd'hui", count: 43, temp: '18°', icon: 'sun-cloud', trend: 'up', chartData: [10, 15, 8, 20, 15, 25, 22] },
        { label: 'Demain', count: 52, temp: '19°', icon: 'sun-cloud', trend: 'up', chartData: [12, 18, 15, 25, 18, 22, 28] },
        { label: 'Samedi prochain', count: 78, temp: '23°', icon: 'sun', trend: 'up', chartData: [15, 20, 18, 30, 25, 20, 25] },
        {
            label: 'Dimanche prochain',
            count: 26,
            temp: '12°',
            icon: 'rain',
            trend: 'down',
            chartData: [25, 22, 18, 15, 18, 20, 15],
        },
    ],
    kpis: [
        {
            label: 'CA réalisé',
            value: '4 200€',
            variation: 25,
            variationLabel: 'Vs semaine dernière',
            icon: 'banknote',
            iconBg: 'linear-gradient(180deg, #4A3AFF 0%, #6D3AFF 100%)', // Blue/Purple gradient
            color: '#4A3AFF',
        },
        {
            label: 'CA encaissé',
            value: '5 478€',
            variation: 12,
            variationLabel: 'Vs semaine dernière',
            icon: 'wallet',
            iconBg: 'linear-gradient(180deg, #C893FD 0%, #D84895 100%)', // Pink/Purple gradient
            color: '#C893FD',
        },
        {
            label: 'Panier moyen',
            value: '78€',
            variation: -3,
            variationLabel: 'Vs semaine dernière',
            icon: 'shopping-basket',
            iconBg: 'linear-gradient(180deg, #7D2DBD 0%, #8D3DCD 100%)', // Purple gradient
            color: '#7D2DBD',
        },
        {
            label: 'Entrées réalisées',
            value: '148',
            variation: -3,
            variationLabel: 'Vs semaine dernière',
            icon: 'ticket',
            iconBg: '#1E1B39', // Darker simplified
            color: '#FFFFFF',
            isWeather: true,
            weatherIcon: 'sun-cloud',
            temp: '16°',
        },
    ],
    lineChart: {
        labels: ['Lundi', 'Mardi', 'Aujourd’hui', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
        datasets: [
            {
                label: 'Encaissé TTC',
                data: [1500, 2300, 4200, 3100, 3900, 1800, 3800],
                color: '#4A3AFF', // Blue/Purple
                fill: true,
            },
            {
                label: 'Réalisé HT',
                data: [500, 1200, 2000, 2800, 1300, 4800, 2100],
                color: '#C893FD', // Light Purple
                fill: true,
            },
        ],
        totalValue: '2,714€',
    },
    paymentMethods: [
        { label: 'CB', value: 25, color: '#4A3AFF' }, // Blue
        { label: 'Apple Pay', value: 15, color: '#C893FD' }, // Light Purple
        { label: 'Espèces', value: 15, color: '#00D589' }, // Green
        { label: 'Cheques', value: 10, color: '#FEC400' }, // Yellow
        { label: 'ANCV', value: 20, color: '#F8F8FF' }, // White/Grey
        { label: 'Autres', value: 15, color: '#292E33' }, // Dark Grey
    ],
    bestSellers: [
        { label: 'Formule Anniversaire', valueN: 48.3, percent: 48.3, icon: 'trophy' },
        { label: 'Paintball', valueN: 23.7, percent: 23.7, icon: 'target' },
        { label: 'Banana Moon', valueN: 22.2, percent: 22.2, icon: 'mask' },
        { label: 'Entrée Parc +8ans', valueN: 5.2, percent: 5.2, icon: 'ticket' },
        { label: 'Simracing - 30 minutes', valueN: 4.5, percent: 4.5, icon: 'car' },
        { label: 'Burger Maison', valueN: 3.0, percent: 3.0, icon: 'burger' },
    ],
    salesStats: [
        { label: 'Services', value: 81.57, color: '#4A3AFF' },
        { label: 'Fidélisation', value: 63.25, color: '#C893FD' },
        { label: 'Restauration', value: 52.95, color: '#FEC400' },
    ],
    clientBase: {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
        datasets: [
            {
                label: 'N',
                data: [3200, 3400, 3500, 3800, 4000, 4100, 4800, 4900, 4200, 4800, 5000, 5200], // Primary bars
                backgroundColor: '#4A3AFF',
            },
            {
                label: 'N-1',
                data: [2800, 3000, 2900, 3200, 3400, 3200, 3500, 3800, 3800, 4000, 4200, 4300], // Secondary bars (thinner or diff color)
                backgroundColor: '#C893FD',
            },
        ],
    },
    clientStats: [
        { label: 'Nombre de clients', value: '5931', variation: 1, subtitle: 'Vs semaine dernière' },
        { label: 'Abonnés aux comms', value: '59', variation: -15, subtitle: 'Vs semaine dernière' },
        { label: 'Hommes', value: '59%', variation: 12, subtitle: 'Vs semaine dernière' },
        { label: 'Femmes', value: '41%', variation: -15, subtitle: 'Vs semaine dernière' },
        { label: 'Taux de rétention', value: '5%', variation: 12, subtitle: 'Vs semaine dernière' },
        { label: 'Nouveaux clients', value: '21%', variation: -15, subtitle: 'Vs semaine dernière' },
        { label: 'Taux de no-show', value: '8%', variation: 12, subtitle: 'Vs semaine dernière' },
        { label: "Taux d'annulation", value: '3%', variation: -15, subtitle: 'Vs semaine dernière' },
    ],
    heatmap: {
        activities: [
            'Formule Anniversaire',
            'Paintball - 30 minutes',
            'Banana Moon',
            'Pulse',
            "Chantel L'expérience",
            'Simulateur F1',
            'Autre activité',
        ],
        hours: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        data: [
            [0, 0, 10, 20, 40, 60, 80, 70, 50, 40, 80, 60, 20, 10, 0, 0], // Activity 1
            [5, 10, 20, 30, 40, 50, 40, 30, 20, 60, 50, 40, 30, 20, 10, 0], // Activity 2
            [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 30, 10, 0], // Activity 3
            [10, 20, 30, 40, 50, 60, 70, 60, 50, 40, 30, 20, 10, 10, 5, 0], // Activity 4
            [0, 0, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 80, 40, 20, 0], // Activity 5
            [5, 5, 10, 20, 30, 40, 30, 20, 10, 20, 30, 40, 30, 20, 10, 5], // Activity 6
            [0, 0, 5, 10, 15, 20, 25, 30, 35, 40, 35, 30, 25, 20, 15, 10], // Activity 7
        ],
    },
    conversionDelays: [
        { label: 'Formule Anniversaire', value: '23,4 jours', variation: 12 },
        { label: 'Paintball', value: '15,2 jours', variation: 8 },
        { label: 'Banana Moon', value: '10,5 jours', variation: -2 },
        { label: 'Pulse', value: '5,1 jours', variation: 5 },
        { label: 'Simulateur F1', value: '2,3 jours', variation: 0 },
    ],
}
